import React, { useState, useEffect } from 'react'
import { Table, IconButton, Icon, ButtonGroup, Modal, Button } from 'rsuite'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import TooltipButton from '../../../components/buttons/TooltipButton'

export default function NotificationOfAssetsTable({
  data,
  loading,
  onDelete,
  onSelect,
  isViewMode,
  useType,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const [tableData, setTableData] = useState([])
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [deleteObj, setDeleteObj] = useState({})
  const [isPreview, setIsPreview] = useState(false)
  const [myMsg, setMyMsg] = useState('')

  useEffect(() => {
    setTableData(data)
  }, [data])

  const handlePreview = (msg) => {
    console.log(msg)
    setMyMsg(msg)
    setIsPreview(true)
  }

  function removeTags(str) {
    if (str === null || str === '') return false
    else str = str.toString()

    // Regular expression to identify HTML tags in
    // the input string. Replacing the identified
    // HTML tag with a null string.
    return str.replace(/(<([^>]+)>)/gi, '')
  }

  return (
    <>
      <Table
        height={600}
        loading={loading}
        data={tableData || []}
        headerHeight={60}
        // wordWrap
      >
        <Column width={70} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>

        <Column width={200} minWidth={200} flexGrow={1}>
          <HeaderCell>ข้อความแจ้งเตือน</HeaderCell>
          {/* <Cell dataKey="message" /> */}
          <Cell>
            {(rowData) => {
              if (!rowData?.message) {
                return ''
              }
              return (
                <>
                  <div
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      // width: '150px',
                    }}
                    dangerouslySetInnerHTML={{
                      __html: removeTags(rowData?.message),
                    }}
                  />
                </>
              )
            }}
          </Cell>
        </Column>
        <Column width={50} minWidth={50}>
          <HeaderCell></HeaderCell>
          <Cell>
            {(rowData) => {
              if (!rowData?.message) {
                return ''
              }
              return (
                <div style={{ marginTop: -5 }}>
                  <TooltipButton
                    isStart={true}
                    icon="eye"
                    tooltip={`More...`}
                    disabled={loading}
                    onClick={() => {
                      handlePreview(rowData?.message)
                    }}
                  ></TooltipButton>
                </div>
              )
            }}
          </Cell>
        </Column>

        <Column width={150} align="center">
          <HeaderCell style={styleHeaderCell}>วันที่เริ่มแจ้งเตือน</HeaderCell>
          <Cell dataKey="notificationStartDate" />
        </Column>

        <Column width={150} align="center">
          <HeaderCell style={styleHeaderCell}>วันที่สิ้นสุดแจ้งเตือน</HeaderCell>
          <Cell dataKey="notificationEndDate" />
        </Column>

        {useType == 1 && (
          <Column width={150} align="center">
            <HeaderCell style={styleHeaderCell}>วันที่ระบบเปิดให้ตรวจนับ</HeaderCell>
            <Cell dataKey="openSystemStartDate" />
          </Column>
        )}

        {useType == 1 && (
          <Column width={150} align="center">
            <HeaderCell style={styleHeaderCell}>วันที่ระบบปิดให้ตรวจนับ</HeaderCell>
            <Cell dataKey="closeSystemStartDate" />
          </Column>
        )}

        {/* <Column width={200}>
          <HeaderCell>สถานะการใช้งาน</HeaderCell>
          <Cell dataKey="isActive" />
        </Column> */}

        <Column width={130} align="center">
          <HeaderCell style={styleHeaderCell}>
            สถานะการใช้งาน
            {/* <div style={styleHeaderCell}>สถานะการใช้งาน</div> */}
          </HeaderCell>
          <Cell align="center">
            {(rowData) => {
              if (rowData.isActive) {
                return <Icon icon="check-circle" size="lg" style={{ color: '#2da888' }} />
              } else {
                return <Icon icon="minus-circle" size="2x" style={{ color: '#8080808a' }} />
              }
            }}
          </Cell>
        </Column>

        {!isViewMode && (
          <Column width={180} align="center" fixed="right">
            <HeaderCell>จัดการ</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    <div style={{ marginTop: -5 }}>
                      <ButtonGroup>
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-edit"
                          icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                          onClick={() => onSelect(rowData)}
                          size="sm"
                          // disabled={!rowData.isEditabled}
                        >
                          แก้ไข
                        </IconButton>
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-cancel"
                          size="sm"
                          icon={<Icon icon="trash" className="bt-gost-icon-none-radius-cancel" />}
                          onClick={() => (setDeleteObj(rowData), setIsShowConfirm(true))}
                          // disabled={!rowData.isEditabled}
                        >
                          ลบ
                        </IconButton>
                      </ButtonGroup>
                    </div>
                  </>
                )
              }}
            </Cell>
          </Column>
        )}
      </Table>

      <ConfirmWidget
        title={`ยืนยันการลบรายการ`}
        show={isShowConfirm}
        // detail={`ยืนยันการลบ`}
        onCancle={() => {
          setIsShowConfirm(false)
          setDeleteObj({})
        }}
        onConfirm={() => {
          onDelete(deleteObj)
          setIsShowConfirm(false)
        }}
      />

      <Modal
        // full
        size="lg"
        show={isPreview}
        onHide={(e) => {
          setIsPreview(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>ข้อความแจ้งเตือน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            // style={{ wordWrap: 'break-word'}}
            dangerouslySetInnerHTML={{
              __html: myMsg,
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setIsPreview(false)
            }}
            appearance="subtle"
          >
            ปิด
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
